import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import TeacherDashboardPage from '../../features/teacher-analytics/components/TeacherDashboardPage';

/**
 * Original teacher dashboard UI (schools, certificates, usage panels)
 * with full tracker usage data (papers, quiz gen, reasoning, etc.).
 */
const TeacherDashboardRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <TeacherDashboardPage />
  </ProtectedRoute>
);

export default TeacherDashboardRoute;
